import VueAnalytics from 'vue-analytics'
import store from '../store'

export default async ({ router, Vue }) => {
	// let ids = []
	// ids.push('UA-53707923-3')

	// if (process.env.ID_GOOGLE_ANALYTICS != '') ids.push(process.env.ID_GOOGLE_ANALYTICS)
	// if (process.env.ID_GOOGLE_ANALYTICS_CLIENT != '') ids.push(process.env.ID_GOOGLE_ANALYTICS_CLIENT)

	// let acceptCookies = store.getters['cookies/gtag']
	// console.log(acceptCookies)
	// Vue.use(VueAnalytics, {
	// 	id: ids,
	// 	checkDuplicatedScript: true,
	// 	router,
	// 	debug: {
	// 		sendHitTask: false
	// 	  }
	// })
}
